module.exports = __webpack_public_path__ + "static/media/workout-buddy.f18ea6e0.jpg";